<template>
  <div class="language text-white text-center">
    <div class="language-label p-relative">
      <span>Ru</span>
      <i class="language-label__icon mt-2 ml-1 p-absolute"></i>
    </div>
    <div class="language-dropdown">
      <a class="language-items">
        Ru
      </a>
      <a class="language-items">
        Eng
      </a>
      <a class="language-items">
        Uzb
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
